import { object, string } from "yup";

export default ({ intl }) => {
  const requiredText = intl.formatMessage({ id: "app.form.required" });
  const validEmailText = intl.formatMessage({ id: "app.form.validEmail" });

  return object().shape({
    email: string()
      .email(validEmailText)
      .required(requiredText),
    locale: string().required(requiredText),
  });
};
